import React from 'react';
import DeckGL from '@deck.gl/react';
import { COORDINATE_SYSTEM, OrbitView } from '@deck.gl/core';
import { LASLoader, LASWorkerLoader } from '@loaders.gl/las';
import { PointCloudLayer } from '@deck.gl/layers';
import { Modal, Stack, Button } from '@mui/material';
import { load, registerLoaders } from '@loaders.gl/core';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useStyles } from '../../../styles/mapStylesCustom';

// eslint-disable no-unused-vars //;
// Additional format support can be added here, see
registerLoaders([LASLoader, LASWorkerLoader]);

const INITIAL_VIEW_STATE = {
  target: [0, 0, 0],
  rotationX: 90,
  rotationOrbit: 0,
  minZoom: -2,
  maxZoom: 10,
  zoom: 1
};

const urlLaz = 'https://lidar.ipsilum.com/sources/PNOA_2016_MAD_424-4486_ORT-CLA-RGB.laz';

const convertLoadersMeshToDeckPointCloudData = attributes => {
  const deckAttributes = {
    getPosition: attributes.POSITION
  };
  if (attributes.COLOR_0) {
    deckAttributes.getColor = attributes.COLOR_0;
  }
  // Check PointCloudLayer docs for other supported props?
  return {
    length: attributes.POSITION.value.length / attributes.POSITION.size,
    attributes: deckAttributes
  };
};

const ShowMapDeckLidarComponent = () => {
  const [viewState, setViewState] = React.useState(INITIAL_VIEW_STATE);
  const [pointData, setPointData] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const classes = useStyles();

  const onLoad = prop => {
    const { attributes, header } = prop;
    if (header.boundingBox) {
      const [mins, maxs] = header.boundingBox;
      // File contains bounding box info
      setViewState({
        ...INITIAL_VIEW_STATE,
        target: [(mins[0] + maxs[0]) / 2, (mins[1] + maxs[1]) / 2, (mins[2] + maxs[2]) / 2],
        zoom: Math.log2(window.innerWidth / (maxs[0] - mins[0])) - 1
      });
    }
    setPointData(convertLoadersMeshToDeckPointCloudData(attributes));
  };
  const layers = [
    new PointCloudLayer({
      id: 'laz-point-cloud-layer',
      data: pointData,
      coordinateSystem: COORDINATE_SYSTEM.LNGLAT,
      getColor: [0, 0, 255],
      sizeUnits: 'meters',
      pointSize: 1,
      material: false
    })
  ];

  React.useEffect(() => {
    load(urlLaz, { las: { skip: 2, colorDepth: 'auto' } }).then(onLoad);
  }, []);

  const getModalStyle = () => {
    const top = 10;
    // const left = 5;

    return {
      top: `${top}%`,
      width: '80%',
      height: '80%'
    };
  };
  const [modalStyle] = React.useState(getModalStyle);
  const handleModal = () => setOpen(true);

  return (
    <>
      <Stack
        alignItems="center"
        color="inherit"
        direction="row"
        justifyContent="space-around"
        size="small"
      >
        <Button
          size="small"
          startIcon={<OpenInNewIcon />}
          style={{ color: '#2A3F90' }}
          variant="outlined"
          onClick={() => {
            handleModal();
          }}
        >
          Abrir mapa
        </Button>
      </Stack>

      <Modal open={open} onClose={() => setOpen(false)} align="center" style={{ mt: '25%' }}>
        <div style={modalStyle} className={classes.modalPaperAux}>
          <DeckGL
            views={new OrbitView(new OrbitView({ orbitAxis: 'Y', fov: 50 }))}
            viewState={viewState}
            controller
            onViewStateChange={v => setViewState(v.viewState)}
            layers={layers}
            parameters={{
              clearColor: [0.93, 0.86, 0.81, 1]
            }}
          />
        </div>
      </Modal>
    </>
  );
};

export default ShowMapDeckLidarComponent;
